import type { TFunction } from 'i18next';

const PASSWORD_VALIDATION_MAP: Record<
  string,
  { key: string; fallback: string }
> = {
  'validation.password.mixed': {
    key: 'auth.passwordValidation.mixed',
    fallback: 'Password must include upper and lower case letters.',
  },
  'validation.password.symbols': {
    key: 'auth.passwordValidation.symbols',
    fallback: 'Password must include at least one symbol.',
  },
  'validation.password.numbers': {
    key: 'auth.passwordValidation.numbers',
    fallback: 'Password must include at least one number.',
  },
};

const MIN_LENGTH_PATTERN = /at least\s+(\d+)\s+characters?/i;

export function resolvePasswordValidationMessage(
  t: TFunction,
  message: string | null | undefined,
): string | undefined {
  if (!message) {
    return undefined;
  }

  const minLengthMatch = message.match(MIN_LENGTH_PATTERN);
  if (minLengthMatch) {
    const count = Number(minLengthMatch[1]);
    if (Number.isFinite(count)) {
      return t(
        'auth.passwordValidation.minLength',
        'Password must be at least {{count}} characters.',
        { count },
      );
    }
  }

  const mapped = PASSWORD_VALIDATION_MAP[message.trim()];
  if (mapped) {
    return t(mapped.key, mapped.fallback);
  }

  return undefined;
}
